import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'whp-highlight-wrapper',
  templateUrl: './whp-highlight-wrapper.component.html',
  styleUrls: ['./whp-highlight-wrapper.component.scss']
})
export class WhpHighlightWrapperComponent implements OnInit {

  constructor() { }

  @Input() PERMISSIONS = [];
  @Input() TITLES = [];
  @Input() APIS = [];
  @Input() TEXTS = [];
  @Input() TOTAL: any = '';
  @Input() COLUMNSIZE = 6;
  deviceWidth = window.innerWidth;

  ngOnInit() {
  }

}
